import React from 'react';

import {BIOENTITY_SUMMARY_SHAPE, BioentitySummary} from 'folder-items/FileConstants';
import {
  SchemaValidationLongDisplayTextByStatus,
  SchemaValidationShortDisplayTextByStatus,
  SchemaValidationStatus,
} from 'schemas/SchemaValidationConstants';
import Tooltip from 'ui-library/bs/Tooltip';

export interface BioentityValidationStatusProps {
  bioentity: BioentitySummary;
}

function BioentityValidationStatus({bioentity}: BioentityValidationStatusProps): JSX.Element | null {
  if (!bioentity.schemaValidationState) {
    return null;
  }
  const status = bioentity.schemaValidationState.status;
  if (status === SchemaValidationStatus.FAILED) {
    return (
      <Tooltip title={SchemaValidationLongDisplayTextByStatus.FAILED}>
        <span className="u-danger-color">{SchemaValidationShortDisplayTextByStatus.FAILED}</span>
      </Tooltip>
    );
  }
  if (status === SchemaValidationStatus.VALIDATING) {
    return (
      <Tooltip title={SchemaValidationLongDisplayTextByStatus.VALIDATING}>
        <span className="u-dark-warning-color">{SchemaValidationShortDisplayTextByStatus.VALIDATING}...</span>
      </Tooltip>
    );
  }
  return null;
}

BioentityValidationStatus.propTypes = {
  bioentity: BIOENTITY_SUMMARY_SHAPE,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export default BioentityValidationStatus;
